import React from "react";
import { LinkButton } from "@catchoftheday/cg-components";
import { URL_ONEPASS_PUBLIC_MIGRATION } from "../../../../consts";
import { generateOnePassConsentUrl } from "../../../../utilities";
export const TransferCTAButton = () => {
    return (<LinkButton href={generateOnePassConsentUrl(URL_ONEPASS_PUBLIC_MIGRATION)} variant="onePassPrimary" sizeVariant="xl" fontWeight="semibold" mb={6}>
      Transfer Now
    </LinkButton>);
};
